import {H1, H2, Text} from "@salt-ds/core";
import {EXISTING_SESSION} from "src/constants/achEnrollment";

const ExisitingSession = () => {

  return (
    <div className="flex justify-center mt-[35px]">
    <div className="w-[684px] inline-flex flex-col justify-start items-start gap-10">
      <div className="self-stretch bg-white flex flex-col justify-start items-start gap-6">
        <div className="w-[684px] h-8 relative">
          <H1 >{EXISTING_SESSION.Heading_1}</H1>
        </div>
        <div className="self-stretch inline-flex justify-start items-start gap-2">
          <H2>{EXISTING_SESSION.Heading_2}</H2>
        </div>
        <div className="self-stretch flex flex-col justify-start items-start gap-2">
          <Text >{EXISTING_SESSION.Text_Description}</Text>
        </div>
      </div>
      <div className="inline-flex justify-start items-center gap-4" />
    </div>
    </div>
  );
}

export default ExisitingSession;